import React from 'react';
import Image from "../assets/IMAGE.png"
import "./testimonials.css";

function Testimonial() {
    return (
        <div>
            <div></div>
            <div className="testimonials">
                
                <div className="bordertestimonials">

                    <div className="quotesbycustomer">
                        <div>
                            Nesciunt et facilis atque incidunt qui voluptatem non. Facere id voluptatem dolore velit a. Laborum dolorum voluptatibus deleniti id id quo ea voluptate incidunt. Laborum reiciendis qui aut officia doloribus veniam quidem dignissimos id. Et aut vel. Numquam quo asperiores impedit aut. Optio dolorem eum quia.
                        </div>
                        <div className='customerimagecontainer'>
                            <img className='customerimage' src={Image} alt="Customer" />
                        </div>
                    </div>

                </div>

                <div className="bordertestimonials">

                    <div className="quotesbycustomer">
                        <div>
                             Nesciunt et facilis atque incidunt qui voluptatem non. Facere id voluptatem dolore velit a. Laborum dolorum voluptatibus deleniti id id quo ea voluptate incidunt. Laborum reiciendis qui aut officia doloribus veniam quidem dignissimos id. Et aut vel. Numquam quo asperiores impedit aut. Optio dolorem eum quia.
                        </div>
                        <div className='customerimagecontainer'>
                            <img className='customerimage' src={Image} alt="Customer" />
                        </div>
                    </div>

                </div>
                
                
            </div>
        </div>
    );
}

export default Testimonial;